import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button, { BUTTON_TYPES } from 'components/common/button-component';
import { FormattedMessage } from 'react-intl';
import NotesTextArea from 'components/feature/notes-panel/_notes-textarea-component';
import { toDisplayNoteFormat } from 'utils/note-filter-util';
import ProjectUsersList from 'models/api/project-users-list-api-model';

export const NOTES_PANEL_INPUT_AREA_BLOCK = 'notes-panel-input-area';
export const NOTES_PANEL_REPLY_INPUT_AREA_ID_BLOCK =
  'notes-panel-reply-input-area-id';

const NoteReplyInputArea = ({
  cancelAddNoteReply,
  createNoteReply,
  projectUsersList,
  reply = '',
}) => {
  const editableText = reply
    ? toDisplayNoteFormat(reply, projectUsersList)
    : reply;
  // Initialize text with the editable format
  const [text, setText] = useState(editableText);

  return (
    <div
      className={NOTES_PANEL_INPUT_AREA_BLOCK}
      id={NOTES_PANEL_REPLY_INPUT_AREA_ID_BLOCK}
    >
      <NotesTextArea
        id={`${NOTES_PANEL_REPLY_INPUT_AREA_ID_BLOCK}-content`}
        placeholder="notes-panel.notes-reply.placeholder"
        onChange={(text) => setText(text)}
        value={text}
        data={projectUsersList.usersListForMentionsTextArea}
      />
      <div className={`${NOTES_PANEL_INPUT_AREA_BLOCK}__button-container`}>
        <Button
          id={`${NOTES_PANEL_INPUT_AREA_BLOCK}__cancel-button`}
          className={`${NOTES_PANEL_INPUT_AREA_BLOCK}__button-container--cancel`}
          type={BUTTON_TYPES.secondary}
          onClick={cancelAddNoteReply}
        >
          <FormattedMessage id="common.cancel" />
        </Button>
        <Button
          id={`${NOTES_PANEL_INPUT_AREA_BLOCK}__add-button`}
          className={`${NOTES_PANEL_INPUT_AREA_BLOCK}__button-container--add`}
          type={BUTTON_TYPES.primary}
          onClick={() => {
            createNoteReply(text);
            setText('');
          }}
          disabled={
            reply
              ? text === editableText || text.trim() === '' // For editing: disable if no changes or empty
              : text.trim() === '' // For new replies: disable if empty
          }
        >
          <FormattedMessage id={reply ? 'common.save' : 'common.add'} />
        </Button>
      </div>
    </div>
  );
};

NoteReplyInputArea.propTypes = {
  /** Action fired for canceling adding a note */
  cancelAddNoteReply: PropTypes.func.isRequired,
  /** Action for creating a note reply */
  createNoteReply: PropTypes.func.isRequired,
  /** List of the elements to render in the suggestions list */
  projectUsersList: PropTypes.instanceOf(ProjectUsersList).isRequired,
  /** The reply text content (empty string for new replies, existing text for edits) */
  reply: PropTypes.string,
};

export default NoteReplyInputArea;
